/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const departments = (state) => {
  return state.departments
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getDeptById = (state) => (id) => {
  return state.departments.find(item => item.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  departments,
  total,
  offset,
  max,
  getDeptById,
  sort,
  order
}
